//change api url
//change token
const api_url = "https://jess-lea-wholesale.myshopify.com/api/2020-07/graphql";
const headers = new Headers({
  "Content-Type": "application/json",
  Accept: "application/json",
  "X-Shopify-Storefront-Access-Token": "ddee8fabadc5e461083b513a988c8978",
});

async function getProducts(ids,toValidate) {
  const query = () =>
    `
    {
      nodes(ids: [` +
    ids +
    `]) {
        ...on Product {
          title
          tags
          handle
        }
      }
    }
  `;
  const response = await fetch(api_url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify({ query: query() }),
  });
  const Shop = await response.json();

  //store products with MIN and MAX tags
  window.jsonCartItemsMin = {};
  window.jsonCartItemsMax = {};
  for (var nodeKey in Shop.data.nodes) {
    if(Shop.data.nodes[nodeKey] != null){
      var hasMin = false;
      var hasMax = false;
      itemTags = Shop.data.nodes[nodeKey].tags;
      for (let i = 0; i < itemTags.length; i++) {
        if (itemTags[i].includes("MIN") || itemTags[i].includes("min")) {
          var arrMinTag = itemTags[i].toLowerCase().split("min");
          if (Number.isInteger(parseInt(arrMinTag[1]))) {
            var jsonCartItem = jsonCartItems[Shop.data.nodes[nodeKey].handle];
            jsonCartItems[Shop.data.nodes[nodeKey].handle].minQty = parseInt(arrMinTag[1]);
            if (typeof window.jsonCartItemsMin[jsonCartItem.handle] == "undefined") {
              window.jsonCartItemsMin[jsonCartItem.handle] = {};
            }
            window.jsonCartItemsMin[jsonCartItem.handle].title = jsonCartItem.product_title;
            window.jsonCartItemsMin[jsonCartItem.handle].minQty = parseInt(arrMinTag[1]);
            if (Number.isInteger(window.jsonCartItemsMin[jsonCartItem.handle].totalQty)) {
              window.jsonCartItemsMin[jsonCartItem.handle].totalQty +=
                jsonCartItem.quantity;
            } else {
              window.jsonCartItemsMin[jsonCartItem.handle].totalQty = jsonCartItem.quantity;
            }
          }
        }
        if (itemTags[i].includes("MAX") || itemTags[i].includes("max")) {
          var arrMaxTag = itemTags[i].toLowerCase().split("max");
          if (Number.isInteger(parseInt(arrMaxTag[1]))) {
            var jsonCartItem = jsonCartItems[Shop.data.nodes[nodeKey].handle];
            jsonCartItems[Shop.data.nodes[nodeKey].handle].maxQty = parseInt(arrMaxTag[1]);
            if (typeof window.jsonCartItemsMax[jsonCartItem.handle] == "undefined") {
              window.jsonCartItemsMax[jsonCartItem.handle] = {};
            }
            window.jsonCartItemsMax[jsonCartItem.handle].title = jsonCartItem.product_title;
            window.jsonCartItemsMax[jsonCartItem.handle].maxQty = parseInt(arrMaxTag[1]);
            if (Number.isInteger(window.jsonCartItemsMax[jsonCartItem.handle].totalQty)) {
              window.jsonCartItemsMax[jsonCartItem.handle].totalQty +=
                jsonCartItem.quantity;
            } else {
              window.jsonCartItemsMax[jsonCartItem.handle].totalQty = jsonCartItem.quantity;
            }
          }
        }
      }
    }
  }
  if(toValidate){
    validateCartMinMax(null,toValidate);
  }
}

function waitForCart(callBack) {
  var interval = setInterval(function () {
    if (window.jsonCart != null) {
      clearInterval(interval);
      callBack();
    }
  }, 200);
}

function minmaxInit(toValidate = false,jsonCart) {
  //add a parameter "jsonCart" to take the cart object so we dont have to call the cart js when we update the cart
  if (!(jsonCart || "")) {
    window.jsonCart = null;
    $.getJSON("/cart.js", function (cart) {
      jsonCart = cart;
      window.jsonCart = jsonCart;
    });
  } else {
    window.jsonCart = jsonCart;
  }

  waitForCart(function(){
    //store in a more accessible key(handle) value json
    window.jsonCartItems = [];
    for (const ind in window.jsonCart.items) {
      if(typeof window.jsonCartItems[window.jsonCart.items[ind].handle] == 'undefined'){
        window.jsonCartItems[window.jsonCart.items[ind].handle] = window.jsonCart.items[ind];
      } else {
        window.jsonCartItems[window.jsonCart.items[ind].handle].quantity += window.jsonCart.items[ind].quantity
      }
    }
    
    minmaxGet(getProducts,toValidate);
  });
}

function minmaxGet(callBack,toValidate) {
  var strIds = "";
  for (const ind in window.jsonCart.items) {
    var lineItem = window.jsonCart.items[ind];
    if (ind == 0) {
      strIds += '"gid://shopify/Product/' + lineItem.product_id + '"';
    } else {
      strIds += "," + '"gid://shopify/Product/' + lineItem.product_id + '"';
    }
  }
  callBack(strIds,toValidate);
}

$('#cart').on('submit',function(evt){
  validateCartMinMax(evt);
});

function validateCartMinMax(evt,prToValidate) {
  var cartMinError = "";
  var cartMaxError = "";
  //variable for showing modal in case the added product form product page does not have issues with min/max or does not have min/max tag
  var showModal = typeof prToValidate == "undefined" ? true : false;
  for(var key in window.jsonCartItemsMin){
    if(prToValidate == null || (showModal == false && key == prToValidate) || prToValidate == 'update'){
      if(window.jsonCartItemsMin[key].minQty > window.jsonCartItemsMin[key].totalQty){
        cartMinError += "<p>Required <em>minimum</em> order quantity of <strong>" + window.jsonCartItemsMin[key].minQty + "</strong> for <strong>" + window.jsonCartItemsMin[key].title + "</strong>\n";
      }
      if(key == prToValidate){
        showModal = true;
      }
    }
  }
  for(var key in window.jsonCartItemsMax){
    if(prToValidate == null || (showModal == false && key == prToValidate) || prToValidate == 'update'){
      if(window.jsonCartItemsMax[key].maxQty < window.jsonCartItemsMax[key].totalQty){
        cartMaxError += "<p>Required <em>maximum</em> order quantity of <strong>" + window.jsonCartItemsMax[key].maxQty + "</strong> for <strong>" + window.jsonCartItemsMax[key].title + "</strong>\n";
      }
      if(key == prToValidate){
        showModal = true;
      }
    }
  }
  if(cartMinError != "" || cartMaxError != ""){
    if(typeof evt != "undefined" && evt != null){
      evt.preventDefault();
    }
    if($('.cart__dynamic-checkout-buttons').length > 0){
      //hide/show dynamic checkout buttons
      $('.cart__dynamic-checkout-buttons').addClass('minmax-hide').fadeOut();
    }
    if(showModal){
      openModal(cartMinError + cartMaxError + "<p>Please fix these cart errors before checking out.</p>");
    }
  } else {
    if($('.cart__dynamic-checkout-buttons').length > 0){
      //hide/show dynamic checkout buttons
      $('.cart__dynamic-checkout-buttons').removeClass('minmax-hide').fadeIn();
    }
  }
}

minmaxInit('update');